import {loadPhoto} from "./facePreview";
import type {FacePoint} from "./makeupPreview";
export type Photo={src:string;points:FacePoint[];personal:boolean};
export type Frame={pixels:ImageData;points:FacePoint[];src:string};
let tabPhoto:Photo|null=null;
export const currentPhoto=()=>tabPhoto;
export const rememberPhoto=(photo:Photo|null)=>{tabPhoto=photo;};
export async function framePhoto(photo:Photo):Promise<Frame>{
  const image=await loadPhoto(photo.src),w=image.naturalWidth,h=image.naturalHeight;
  const faceWidth=Math.abs(photo.points[454].x-photo.points[234].x)*w;
  const cw=Math.min(w,faceWidth*2.15),ch=Math.min(h,cw*1.25);
  const cx=(photo.points[454].x+photo.points[234].x)*w/2;
  const left=Math.max(0,Math.min(w-cw,cx-cw/2));
  const top=Math.max(0,Math.min(h-ch,photo.points[10].y*h-ch*.13));
  const canvas=document.createElement("canvas");canvas.width=Math.min(900,Math.round(cw));canvas.height=Math.round(ch*canvas.width/cw);
  const ctx=canvas.getContext("2d",{willReadFrequently:true})!;ctx.drawImage(image,left,top,cw,ch,0,0,canvas.width,canvas.height);
  return {pixels:ctx.getImageData(0,0,canvas.width,canvas.height),src:canvas.toDataURL("image/jpeg",.94),points:photo.points.map(p=>({x:(p.x*w-left)/cw,y:(p.y*h-top)/ch}))};
}
